import React, { useState } from "react";
import styles from "../styles/BrowserScreenshotContainerStyles";

const BrowserScreenshotContainer = ({ imageSrc, noScreenshot, onClose }) => {
  const [position, setPosition] = useState({ top: 20, left: 20 });
  const [dragging, setDragging] = useState(false);
  const [rel, setRel] = useState({ x: 0, y: 0 });

  const onMouseDown = (e) => {
    setDragging(true);
    setRel({
      x: e.pageX - position.left,
      y: e.pageY - position.top,
    });
    e.preventDefault();
  };

  const onMouseMove = (e) => {
    if (!dragging) return;
    setPosition({
      top: e.pageY - rel.y,
      left: e.pageX - rel.x,
    });
    e.preventDefault();
  };

  const onMouseUp = () => {
    setDragging(false);
  };

  return (
    <div
      style={{
        ...styles.screenshotContainer,
        top: position.top,
        left: position.left,
      }}
      onMouseDown={onMouseDown}
      onMouseMove={onMouseMove}
      onMouseUp={onMouseUp}
    >
      <div style={styles.browserHeader}>
        <div
          style={{ ...styles.browserButton, backgroundColor: "#ff5f57" }}
          onClick={onClose} // Close the UI when red button is clicked
        />
        <div style={{ ...styles.browserButton, backgroundColor: "#ffbd2e" }} />
        <div style={{ ...styles.browserButton, backgroundColor: "#28c840" }} />
      </div>
      {imageSrc ? (
        <img src={imageSrc} alt="Screenshot" style={styles.image} />
      ) : noScreenshot ? (
        <h2>No Screenshot Available</h2>
      ) : null}
    </div>
  );
};

export default BrowserScreenshotContainer;
